import { setSelectedEventsDetails } from "./auth.slice";
import { apiMutaion } from "../ApiMutaion";

export const updateExamIdMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  if (setSelectedEventsDetails.match(action)) {
    const selectedEvent = action.payload;
    const allowedSources = ["scheduled", "past_unattempted"];

    if (selectedEvent?.qu_id && allowedSources.includes(selectedEvent?.source)) {
      store.dispatch(
        apiMutaion.endpoints.updateExamID.initiate(selectedEvent.qu_id, {
          forceRefetch: true
        })
      );
    }
  }

  return result;
};
